import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ต่ออายุ Work Permit ไทย — ครบทุกเงื่อนไข 4:1 และรายได้ขั้นต่ำ","metaTitle":"ต่อ Work Permit ไทย — Renewal ครบวงจร | NYC Legal","metaDesc":"บริการต่ออายุใบอนุญาตทำงาน (WP.5) รวม 90-day extension คู่กัน เงินเดือนขั้นต่ำและอัตราส่วน 4:1 คนไทย — ปรึกษาฟรี ประเมินงานให้ทันที ทักไลน์ได้เลย"},"en":{"h1":"Thailand Work Permit Renewal — 4:1 Ratio & Salary Compliance","metaTitle":"Thailand Work Permit Renewal (WP.5) — Full Service | NYC Legal","metaDesc":"Yearly Work Permit renewal plus 1-year Non-B extension — salary bands, 4:1 Thai-staff ratio, tax and — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/work-permit/renewal")({
  head: () => {
    const url = `${SEO_SITE}/work-permit/renewal`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/work-permit/renewal", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/work-permit/renewal", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/work-permit/renewal", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/work-permit/renewal", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/work-permit/renewal", "/en/work-permit/renewal")],
    };
  },
  component: () => <SubServicePage slug="work-permit/renewal" locale="th" />,
});
